"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLevelSettingsSerializer = void 0;
var user_level_settings_model_1 = require("../../models/user-level-settings.model");
var user_setting_options_model_1 = require("../../models/user-setting-options.model");
/**
 * Serializes User Level Settings
 *
 */
var UserLevelSettingsSerializer = /** @class */ (function () {
    function UserLevelSettingsSerializer() {
    }
    UserLevelSettingsSerializer.prototype.serialize = function (_a) {
        var userId = _a.userId, type = _a.type, options = _a.options;
        return new user_level_settings_model_1.UserLevelSettings({
            userId: userId,
            type: type,
            options: new user_setting_options_model_1.UserSettingOptions(options),
        });
    };
    return UserLevelSettingsSerializer;
}());
exports.UserLevelSettingsSerializer = UserLevelSettingsSerializer;
